import { pdfjs } from 'react-pdf';

// Keep worker local to the app build to avoid CDN resolution errors.
pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
